<template>
    <div>
        <div v-if="creativeKidsNewUi">
            <CreativeKids
                :tuo-client="tuoClient"
                :save-page="creativeKidsContactDetail"
            />
        </div>
        <div v-else-if="updatedDetails.length !== 0">
            <div v-if="saveAll && !saveError">
                <UpdateDetailsSaveAll
                    v-if="saveSuccess === undefined"
                    :updated-details="updatedDetails"
                    :on-save-update="saveCustomerUpdate"
                />
                <SaveSusses
                    v-if="saveSuccess"
                />
            </div>
            <div v-else-if="!saveError">
                <UpdateDetails
                    v-if="saveSuccess === undefined"
                    :updated-details="updatedDetails"
                    :on-save-update="saveCustomerUpdate"
                />
                <div v-if="saveSuccess">
                    <Notice
                        id="tuo-confirm-success-message"
                        header="Your information was saved successfully."
                        message="View, update or add information in the 'Personal Details' section of your MyServiceNSW Account."
                        notice-type="SUCCESS"
                    />
                    <Button
                        secondary
                        @click="goToMyServiceNSW"
                    >
                        Go to MyServiceNSW Account
                    </Button>
                </div>
            </div>
            <div v-if="saveError">
                <Notice
                    id="tuo-confirm-failed-message"
                    header="Sorry, something went wrong on our end."
                    message="We're unable to save your information to your MyServiceNSW Account at this time."
                    secondary-message="You can still save your details in the 'Personal Details' section of your MyServiceNSW Account."
                    notice-type="ERROR"
                />
                <Button
                    id="tuo-goto-myservicensw-button"
                    secondary
                    @click="goToMyServiceNSW"
                >
                    Go to MyServiceNSW Account
                </Button>
            </div>
        </div>
    </div>
</template>

<script>
    import ServiceNSWTellUsOnce from '@snsw/tuo-js-client'
    import UpdateDetails from './UpdateDetails'
    import Notice from '../components/Notice'
    import UpdateDetailsSaveAll from './UpdateDetailsSaveAll'
    import SaveSusses from './SaveSusses'
    import gaTrackerAdapter from '../utils/gaTrackerAdapter'
    import Button from '../components/Button'
    import CreativeKids from './CreativeKids'
    import * as AbTestFlag from '../utils/abTestingUtil'

    export default {
        name: 'WidgetWrapper',
        components: { UpdateDetails, UpdateDetailsSaveAll, CreativeKids, SaveSusses, Notice, Button },
        props: {
            url: {
                type: String,
                default: ''
            },
            scrollToTop: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            saveAll: AbTestFlag.saveAll(),
            saveSuccess: undefined,
            saveError: undefined,
            updatedDetails: [],
            tuoClient: undefined,
            creativeKidsContactDetail: window.location.href.includes('creative-kids/parent'),
            creativeKidsConfirmPage: window.location.href.includes('creative-kids/confirmation'),
            creativeKidsNewUi: undefined
        }),
        async created() {
            this.tuoClient = new ServiceNSWTellUsOnce({
                tellUsOnceUrl: this.url,
                useScriptTag: true
            })

            if (this.creativeKidsContactDetail) {
                this.creativeKidsNewUi = AbTestFlag.create()
                if (!this.creativeKidsNewUi) {
                    const dataToSave = window.sessionStorage.getItem('tuoCurrentData')
                    window.sessionStorage.setItem('tuoSavedData', dataToSave)
                }
                return
            } else if (this.creativeKidsConfirmPage) {
                this.creativeKidsNewUi = AbTestFlag.get()
                if (this.creativeKidsNewUi) {
                    return
                }
            }

            const customerUpdate = await this.tuoClient.getCustomerUpdate()

            this.updatedDetails = customerUpdate.filter( item => item['name'] !== 'medicare' && item['name'] !== 'driverLicence')

            if (this.updatedDetails.length > 0) {
                gaTrackerAdapter.trackEvent(
                    'Load Component',
                    (this.saveAll ? 'SaveAll' : '') + 'OfferedToStoreUpdatedDetails',
                    window.location.href)
            }
        },
        methods: {
            saveCustomerUpdate(detailsToSave) {
                let saveValue = detailsToSave.length === this.updatedDetails.length ? 'true' : 'false'
                this.tuoClient.saveCustomerUpdate(detailsToSave,
                    () => {
                        //dimension1 is 'savedAll'
                        gaTrackerAdapter.trackEvent(
                            'Save',
                            (this.saveAll ? 'SaveAll' : '') + 'AgreedToStoreUpdatedDetails',
                            window.location.href,
                            {dimension1: saveValue})
                        this.saveSuccess = true
                    },
                    () => {
                        gaTrackerAdapter.trackEvent(
                            'Error',
                            (this.saveAll ? 'SaveAll' : '') + 'AgreedToStoreUpdatedDetails',
                            window.location.href,
                            {dimension1: saveValue})
                        this.saveError = true
                    }
                )
            },
            goToMyServiceNSW() {
                window.open(process.env.VUE_APP_MYACCOUNT_DASHBOARD_URL)
            },
        }
    }
</script>
